import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import SearchBanner from "@/pages/home/components/SearchBanner";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import DramaSection from "@/pages/home/components/DramaSection";
import TopicSection from "@/pages/home/components/TopicSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { getHotDramas, getLatestDramas } from "@/utils/drama";

const highlights = [
  { icon: "ri-shield-check-line", text: "内容信息整理自公开资料，仅供观影选择参考" },
  { icon: "ri-time-line", text: "列表按上线时间排序，新作第一时间收录" },
  { icon: "ri-compass-3-line", text: "类型与年份组合筛选，快速定位想看的片子" },
];

export default function Home() {
  const latest = getLatestDramas(12);
  const hot = getHotDramas(6);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />

      <main className="w-full flex-1 pt-16">
        <h1 className="sr-only">国产精品久久 - 高清国产影视大片汇聚平台</h1>

        <HeroCarousel items={getHotDramas(4)} />

        <div className="w-full bg-background-50 px-4 pt-6 md:px-8 md:pt-8">
          <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-3 sm:grid-cols-3">
            {highlights.map((item) => (
              <div
                key={item.text}
                className="flex items-center gap-2.5 rounded-md border border-background-200 bg-background-100 px-3 py-2.5"
              >
                <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary-700">
                  <i className={`${item.icon} text-base`} />
                </span>
                <span className="text-xs text-foreground-700 md:text-[13px]">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        <SearchBanner />
        <CategoryShortcuts />

        <div className="w-full px-4 pb-4 md:px-8">
          <div className="mx-auto w-full max-w-6xl">
            <DramaSection
              title="最新上线"
              subtitle="按更新时间倒序，最近收录的国产影视作品"
              moreTo="/category?sort=latest"
              items={latest}
            />
          </div>
        </div>

        <div className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-12">
          <div className="mx-auto w-full max-w-6xl">
            <DramaSection
              title="热门影视榜"
              subtitle="按站内热度虚拟排序，看看大家都在关注什么"
              moreTo="/category?sort=hot"
              moreLabel="查看完整榜单"
              items={hot}
              showRank
              columnsClassName="grid-cols-2 sm:grid-cols-3 lg:grid-cols-6"
            />
            <div className="mt-6 flex flex-col items-start justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-4 sm:flex-row sm:items-center md:px-5">
              <p className="flex items-center gap-2 text-xs text-foreground-700 md:text-sm">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                  <i className="ri-fire-line" />
                </span>
                榜单热度由站内浏览与收藏数据模拟生成，仅作推荐参考
              </p>
              <Link
                to="/category?sort=rating"
                className="flex items-center gap-1 text-xs font-medium text-primary-700 transition-colors hover:text-primary-800 cursor-pointer whitespace-nowrap md:text-sm"
              >
                按口碑排序看看
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>

        <TopicSection />
        <SiteIntro />
      </main>

      <SiteFooter />
    </div>
  );
}